import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import ConsentBoxes from "@/components/ConsentBoxes";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function WhatsAppPrompt() {
  const { user, setUser } = useAuth();
  const [num, setNum] = useState("");
  const [consent, setConsent] = useState({ consent_account: false, consent_marketing: false });
  const [busy, setBusy] = useState(false);
  if (!user?.whatsapp_prompt) return null;
  const askNumber = !user.whatsapp;

  const save = async (skip) => {
    setBusy(true);
    try {
      const body = skip ? { whatsapp: null, consent_account: false, consent_marketing: false } : { whatsapp: num.trim() || null, ...consent };
      const { data } = await api.put("/auth/whatsapp", body);
      setUser({ ...user, ...body, whatsapp: data.whatsapp, whatsapp_prompt: false });
      if (!skip) toast.success("Thank you! Your preferences are saved.");
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={(e) => { e.preventDefault(); save(false); }} data-testid="whatsapp-prompt"
      className="nb-card bg-green-50 border-2 border-slate-900 p-4 mb-6 flex flex-col sm:flex-row gap-4">
      <div className="w-10 h-10 rounded-full bg-[#25D366] border-2 border-slate-900 flex items-center justify-center shrink-0"><MessageCircle size={20} /></div>
      <div className="flex-1 space-y-3">
        <div>
          <p className="font-bold">{askNumber ? "Add your WhatsApp number" : "Stay in touch"}</p>
          <p className="text-sm text-slate-600">So we can help you quickly with payments and your child's access.</p>
        </div>
        {askNumber && (
          <Input value={num} onChange={(e) => setNum(e.target.value)} placeholder="WhatsApp: 5XXX XXXX (optional)" inputMode="tel"
            className="h-10 max-w-xs rounded-xl border-2 border-slate-900 bg-white" data-testid="whatsapp-prompt-input" />
        )}
        <ConsentBoxes value={consent} onChange={setConsent} />
      </div>
      <div className="flex sm:flex-col gap-2 sm:justify-center">
        <Button type="submit" disabled={busy} className="h-10 rounded-full bg-slate-900" data-testid="whatsapp-prompt-save">Save</Button>
        <Button type="button" variant="ghost" disabled={busy} onClick={() => save(true)} className="h-10 rounded-full" data-testid="whatsapp-prompt-skip">Not now</Button>
      </div>
    </form>
  );
}
